import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import { componentGenerator } from '@wix/gena';
import { getBackendEventExtensionPath } from '@wix/cli-astro-definitions';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import { getExtensionRelativePaths } from '../utils/extension-relative-paths.js';

const EVENT_TEMPLATE = path.resolve(__dirname, '../templates/astro/event');

export async function generateEvent(projectFolder: string, route: string) {
  const cwd = getBackendEventExtensionPath(projectFolder, route);
  const { relativePathToCodeFile, relativePathToConfigFile } =
    getExtensionRelativePaths({
      cwd,
      projectFolder,
      extensionFileName: route,
      codeFileType: 'ts',
    });

  const config = {
    id: randomUUID(),
    source: relativePathToCodeFile,
  };

  await modifyExtensionsEntry(
    projectFolder,
    camelCase(route),
    relativePathToConfigFile
  );

  return await componentGenerator({
    template: EVENT_TEMPLATE,
    cwd,
    projectFolder,
    data: {
      route,
      config,
    },
  });
}
